import { Grid, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { PqrReceptionChannelActionsProps } from './props';
import { usePqrReceptionChannelListActions } from './hook';

export const PqrReceptionChannelListActions = ({
    id,
}: PqrReceptionChannelActionsProps) => {
    const { handleEdit } = usePqrReceptionChannelListActions(id);

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
